import DataServiceSQL from "../DataService/DataServiceSQL";
import Utils from "../Components/Common/Utils.js";
import DefaultPatient from '../Components/Patient/PatientDefaultParams.js';

const prismacloudPatientById = async (id_patient) => {
  return await DataServiceSQL.prismacloudPatientById(id_patient)
  .then(response => {
    return response.data;
  })
  .catch(e => {
    console.log(e);
    return Utils.convertTextToFormattedMessageIdError(e.response.data);
  });  
}

const update_SQL_patient = async (data) => {
  const date = new Date();

  const eventDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
  ).toISOString();

  let birthdate = ""
  if (data.Patient_Data.birthdate !== undefined && data.Patient_Data.birthdate !== null && data.Patient_Data.birthdate !== "") {
    birthdate = new Date(
        data.Patient_Data.birthdate
    ).toISOString();
  }

  if (typeof(data.Patient_Data.alerts.sms_alert) === "string") {
    data.Patient_Data.alerts.sms_alert = [data.Patient_Data.alerts.sms_alert]
  }
  if (typeof(data.Patient_Data.alerts.sms_alert_reminder) === "string") {
    data.Patient_Data.alerts.sms_alert_reminder = [data.Patient_Data.alerts.sms_alert_reminder]
  }
  if (typeof(data.Patient_Data.alerts.sms_alert_night) === "string") {
    data.Patient_Data.alerts.sms_alert_night = [data.Patient_Data.alerts.sms_alert_night]
  }
  if (typeof(data.Patient_Data.alerts.sms_alert_reminder_night) === "string") {
    data.Patient_Data.alerts.sms_alert_reminder_night = [data.Patient_Data.alerts.sms_alert_reminder_night]
  }

  if (data.Patient_Data.group === "nogroup") {
    data.Patient_Data.group = null
  }

  if (data.Patient_Data.monitoring_activation === "no") {
    data.Patient_Data.module_activation.forEach(m => {
      m.used = false
    })
  }

  let new_data = {
    "resourceType" : "Patient",
    "identifier" : {
      "value" : data.Patient_Data.id_patient
    },
    "name" : [{
      "use" : "official",
      "family" : data.Patient_Data.lastname,
      "given" : [data.Patient_Data.firstname]
    }],
    "_birthDate" : {
      "extension" : [{
        "url" : "http://hl7.org/fhir/StructureDefinition/patient-birthTime",
        "valueDateTime" : birthdate
      }]
    },
    "group": data.Patient_Data.group,
    "location": data.Patient_Data.location,
    "correspondant": null,
    "external_user_mail": data.external_user_mail,
    "monitoring": {
      "device1":data.Patient_Data.devices.device1.id,
      "device2":data.Patient_Data.devices.device2.id,
      "device3":data.Patient_Data.devices.device3.id,
      "device4":data.Patient_Data.devices.device4.id,
      "device5":data.Patient_Data.devices.device5.id,
      "gateway":data.Patient_Data.devices.gateway.id,
      "smartphone":(data.Patient_Data.monitoring_activation === "smartphone"),
      "no_device":(data.Patient_Data.monitoring_activation === "no_device")
    },
    "alerts": data.Patient_Data.alerts,
    "module_activation": data.Patient_Data.module_activation,
    "alert_recall": data.Patient_Data.alert_recall,
    "concerned_speciality": data.Patient_Data.concerned_speciality || null
  }

  if (new_data.monitoring.device5 === "") {
    new_data.monitoring.device5 = "dissociate"
  }

  if (new_data.alerts.reminder_alert !== undefined && new_data.alerts.reminder_alert.alerts_params !== undefined 
    && new_data.alerts.reminder_alert.alerts_params.length > 0) {    
    let i = 0;
    while (new_data.alerts.reminder_alert.alerts_params[i]) {
      if (typeof(new_data.alerts.reminder_alert.alerts_params[i].alert_hours) === "object") {
        new_data.reminder_alert.alerts_params[i].alert_hours = new_data.reminder_alert.alerts_params[i].alert_hours.join(",")
      }
      i++;
    }
  }

  let sms_alert_reminder_corrected = ['']
  if (new_data.alerts !== undefined && new_data.alerts.sms_alert_reminder !== undefined && new_data.alerts.sms_alert_reminder !== null && typeof(new_data.alerts.sms_alert_reminder) === "string") {
    sms_alert_reminder_corrected = new_data.alerts.sms_alert_reminder.split(',')
  }
  else if (new_data.alerts !== undefined && new_data.alerts.sms_alert_reminder !== undefined && new_data.alerts.sms_alert_reminder !== null && typeof(new_data.alerts.sms_alert_reminder) === "object") {
    sms_alert_reminder_corrected = new_data.alerts.sms_alert_reminder
  }
  new_data.alerts.sms_alert_reminder = sms_alert_reminder_corrected
  return await DataServiceSQL.updatePatient_fhir(new_data, data.Patient_Data.id_patient)
  .then(response => {
    return true;
  })
  .catch(e => {
    console.log(e);
    return Utils.convertTextToFormattedMessageIdError(e.response.data);
  });

  return(true)
 }       

const create_patient_fhir = async (data) => {
  let newProfileObject
  let date = new Date()
  const period = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
  ).toISOString();
  const birthdate = new Date(
      data.Patient_Data.birthdate.getFullYear(),
      data.Patient_Data.birthdate.getMonth(),
      data.Patient_Data.birthdate.getDate()+1,
      data.Patient_Data.birthdate.getHours(),
      data.Patient_Data.birthdate.getMinutes(),
      data.Patient_Data.birthdate.getSeconds()
  ).toISOString();

  if (data.Patient_Data.group.id_group === "nogroup" || data.Patient_Data.group.id_group === "null") {
    data.Patient_Data.group.id_group = null
  }

  newProfileObject = {
    "resourceType" : "Patient",
    "identifier" : {
      "value" : data.Patient_Data.id_patient
    },
    "name" : [{
      "use" : "official",
      "family" : data.Patient_Data.lastname,
      "given" : [data.Patient_Data.firstname]
    }],
    "sex" : Utils.ins_convert_sex(data.Patient_Data.sex),
    "_birthDate" : {
      "extension" : [{
        "url" : "http://hl7.org/fhir/StructureDefinition/patient-birthTime",
        "valueDateTime" : birthdate
      }]
    },
    "template": data.template,
    "external_user_mail": data.external_user_mail,
    "group": data.Patient_Data.group.id_group,
    "birthPlace": data.Patient_Data.birthplace,
    "insData": data.Patient_Data.ins
  }
  if (data.Patient_Data.provider !== false) {
    newProfileObject.provider= data.Patient_Data.provider
  }
  return await DataServiceSQL.createPatient_fhir(newProfileObject)
  .then(response => {
      if (response.data.message !== undefined) {
        return response.data.message
      }
      return true;
  })
  .catch(e => {
    console.log(e);
    return false;
  });
}

//Function to retrieve profile information of a specific profile with axios http request
const get_Patients = async (critere, id_critere) => {

  let search_arg
  if (critere === "patient") {
    search_arg = "identifier"
  }
  else if (critere === "group") {
    search_arg = "group"
  }

  return await DataServiceSQL.getPatient_fhir(search_arg, id_critere)
    .then(response => {
      return(response.data.entry);
    })
    .catch(e => {
      console.log("error while getting " + search_arg + " " + id_critere)
    });
};


//Function to retrieve profile information of a specific profile with axios http request
const search_Patients = async (id_critere) => {

    return await DataServiceSQL.researchINSPatients(id_critere)
    .then(response => {
      return(response);
    })
    .catch(e => {
        console.log("error while searching patients")
    });
};

const convert_patient_input_data = (object, last_Profile_Info_all, struct_devices, accountInformation) => {

    // start by setting default profile
    let new_Profile_Info = (DefaultPatient.getPatientDefaultParams()).Patient_Data;

    //general data
    new_Profile_Info.birthdate = object.birthdate;
    if (object.name !== undefined) {      
      new_Profile_Info.firstname = object.name[0].given[0];
      new_Profile_Info.lastname = object.name[0].family;
    }
    new_Profile_Info.gender = object.gender;
      
    object.id_patient = object.identifier;
    new_Profile_Info.id_patient = object.identifier;
    new_Profile_Info.serialNumber = object.identifier;	// TMP, to be removed

    new_Profile_Info.share_info = {owner: '', structure_shared: {name: '', id: ''}}


    //INS data
    if (object.ins_data !== undefined) {
      new_Profile_Info.INS_Data.NumIdentifiant = object.ins_data.NumIdentifiant;
      new_Profile_Info.INS_Data.Cle = object.ins_data.Cle;
      if (parseInt(new_Profile_Info.INS_Data.Cle) < 10) {
          new_Profile_Info.INS_Data.Cle = "0" + new_Profile_Info.INS_Data.Cle;
      }
      new_Profile_Info.INS_Data.OID = object.ins_data.OID;
      new_Profile_Info.INS_Data.NomUtilise = object.ins_data.NomUtilise;
      new_Profile_Info.INS_Data.NomNaissance = object.ins_data.NomNaissance;
      new_Profile_Info.INS_Data.PremierPrenom = object.ins_data.PremierPrenom;
      new_Profile_Info.INS_Data.PrenomUtilise = object.ins_data.PrenomUtilise;
      new_Profile_Info.INS_Data.PrenomNaissance = object.ins_data.PrenomNaissance;
      new_Profile_Info.INS_Data.DateNaissance = object.ins_data.DateNaissance;
      new_Profile_Info.INS_Data.Sex = object.ins_data.Sex;
      new_Profile_Info.INS_Data.LieuNaissance = object.ins_data.LieuNaissance;
      new_Profile_Info.INSHISTO = object.ins_data.INSHISTO;
    }
    new_Profile_Info.correspondant = object.correspondant;
    new_Profile_Info.concerned_speciality = object.concerned_speciality || null;
    new_Profile_Info.rpps_id_practioner_speciality = object.rpps_id_practioner_speciality || null;
    new_Profile_Info.ordonnance_filename = object.ordonnance_filename || null;
    new_Profile_Info.consentement_filename = object.consentement_filename || null;
    new_Profile_Info.psad_delegate_alerts = object.psad_delegate_alerts || false;
    new_Profile_Info.psad_delegate = object.psad_delegate || null;
    new_Profile_Info.lpp_code = object.lpp_code || null;
    new_Profile_Info.delegate_medical_alert = object.delegate_medical_alert || null;
    new_Profile_Info.delegate_non_medical_alert = object.delegate_non_medical_alert || null;
    new_Profile_Info.manage_tls_user = object.manage_tls_user || null;
    // Device management right for the current user on this patient (owner/admin or
    // a structure share with can_manage_devices). Defaults to true when absent so
    // owners are never accidentally locked out; the backend remains the real gate.
    new_Profile_Info.can_manage_devices = object.can_manage_devices !== undefined ? object.can_manage_devices : true;
    // Subscription features of the patient's owning structure — used so a shared
    // viewer sees the patient's device/sensor data per the owner's subscription,
    // not their own (which may be null/limited). Null when unavailable.
    new_Profile_Info.subscription_features = (object.subscription_features !== undefined && object.subscription_features !== null)
      ? object.subscription_features
      : null;
    // Authoritative resolved devices of the patient (any structure). Kept so the
    // param-edit can tell a real cross-structure device from a genuinely removed one.
    new_Profile_Info.devices_resolved = object.devices_resolved || null;

    //other data
    new_Profile_Info.FK_User_mail = object.FK_User_mail;
    new_Profile_Info.owner_structure_name = object.owner_structure_name || null;
    new_Profile_Info.alerts = object.alerts;
    if (new_Profile_Info.alerts !== undefined && new_Profile_Info.alerts.reminder_alert.alerts_params !== undefined && new_Profile_Info.alerts.reminder_alert.alerts_params !== undefined) {
        new_Profile_Info.alerts.reminder_alert.alerts_params = Utils.reminderAlertHoursConvert(new_Profile_Info.alerts.reminder_alert.alerts_params)
    }
    new_Profile_Info.group = object.group;
    new_Profile_Info.location = object.location;
    new_Profile_Info.module_activation = object.module_activation;
    new_Profile_Info.niv_provider = object.niv_provider;
    new_Profile_Info.alert_recall = object.alert_recall;
    new_Profile_Info.alerts_triggered = object.alerts_triggered;

    new_Profile_Info.shares = object.shares;
    new_Profile_Info.check_patient = object.check_patient || null;

    
    // Monitoring config conversion
    new_Profile_Info.devices.device1.id = object.monitoring.device1;
    new_Profile_Info.devices.device2.id = object.monitoring.device2;
    new_Profile_Info.devices.device3.id = object.monitoring.device3;
    new_Profile_Info.devices.device4.id = object.monitoring.device4;
    new_Profile_Info.devices.device5.id = object.monitoring.device5;
    new_Profile_Info.devices.gateway.id = object.monitoring.gateway;

    new_Profile_Info.monitoring_activation = "no"
    if (object.monitoring.smartphone){
      new_Profile_Info.monitoring_activation = "smartphone"
      new_Profile_Info.devices.gateway.id = "dissociate";
    }
    else if (object.monitoring.no_device){
      new_Profile_Info.monitoring_activation = "no_device"
    }
    else{
      if(object.monitoring.gateway !== "dissociate"){
        new_Profile_Info.monitoring_activation = "gateway"
      }
    }

    if (accountInformation.role !== "registered") {
    if (new_Profile_Info.devices.device1.id !== "dissociate") {
      let device1 = struct_devices.find(deviceData => deviceData.id_device === new_Profile_Info.devices.device1.id)
      if (device1 !== undefined) {
        new_Profile_Info.devices.device1.id = device1.id_device
        new_Profile_Info.devices.device1.id_old = ""
        new_Profile_Info.devices.device1.nickname = device1.nickname
        new_Profile_Info.devices.device1.sn = device1.sn
        new_Profile_Info.devices.device1.type = device1.type
      }
      else if (object.devices_resolved && object.devices_resolved.device1 && object.devices_resolved.device1.id !== "dissociate") {
        // Device belongs to another structure (shared patient): use backend-resolved details.
        new_Profile_Info.devices.device1.id = object.devices_resolved.device1.id
        new_Profile_Info.devices.device1.id_old = ""
        new_Profile_Info.devices.device1.nickname = object.devices_resolved.device1.nickname
        new_Profile_Info.devices.device1.sn = object.devices_resolved.device1.sn
        new_Profile_Info.devices.device1.type = object.devices_resolved.device1.type
      }
    }
      else {
        new_Profile_Info.devices.device1.id = "dissociate"
        new_Profile_Info.devices.device1.id_old = ""
        new_Profile_Info.devices.device1.nickname = "smartphone"
        new_Profile_Info.devices.device1.sn = ""
        new_Profile_Info.devices.device1.type = "tucky_smartphone"        
      }
    if (new_Profile_Info.devices.device2.id !== "dissociate") {
      let device2 = struct_devices.find(deviceData => deviceData.id_device === new_Profile_Info.devices.device2.id)
      if (device2 !== undefined) {
        new_Profile_Info.devices.device2.id = device2.id_device
        new_Profile_Info.devices.device2.id_old = ""
        new_Profile_Info.devices.device2.nickname = device2.nickname
        new_Profile_Info.devices.device2.sn = device2.sn
        new_Profile_Info.devices.device2.type = device2.type
      }
      else if (object.devices_resolved && object.devices_resolved.device2 && object.devices_resolved.device2.id !== "dissociate") {
        // Device belongs to another structure (shared patient): use backend-resolved details.
        new_Profile_Info.devices.device2.id = object.devices_resolved.device2.id
        new_Profile_Info.devices.device2.id_old = ""
        new_Profile_Info.devices.device2.nickname = object.devices_resolved.device2.nickname
        new_Profile_Info.devices.device2.sn = object.devices_resolved.device2.sn
        new_Profile_Info.devices.device2.type = object.devices_resolved.device2.type
      }
    }
    if (new_Profile_Info.devices.device3.id !== "dissociate") {
      let device3 = struct_devices.find(deviceData => deviceData.id_device === new_Profile_Info.devices.device3.id)
      if (device3 !== undefined) {
        new_Profile_Info.devices.device3.id = device3.id_device
        new_Profile_Info.devices.device3.id_old = ""
        new_Profile_Info.devices.device3.nickname = device3.nickname
        new_Profile_Info.devices.device3.sn = device3.sn
        new_Profile_Info.devices.device3.type = device3.type
      }
      else if (object.devices_resolved && object.devices_resolved.device3 && object.devices_resolved.device3.id !== "dissociate") {
        // Device belongs to another structure (shared patient): use backend-resolved details.
        new_Profile_Info.devices.device3.id = object.devices_resolved.device3.id
        new_Profile_Info.devices.device3.id_old = ""
        new_Profile_Info.devices.device3.nickname = object.devices_resolved.device3.nickname
        new_Profile_Info.devices.device3.sn = object.devices_resolved.device3.sn
        new_Profile_Info.devices.device3.type = object.devices_resolved.device3.type
      }
    }
    if (new_Profile_Info.devices.device4.id !== "dissociate") {
      let device4 = struct_devices.find(deviceData => deviceData.id_device === new_Profile_Info.devices.device4.id)
      if (device4 !== undefined) {
        new_Profile_Info.devices.device4.id = device4.id_device
        new_Profile_Info.devices.device4.id_old = ""
        new_Profile_Info.devices.device4.nickname = device4.nickname
        new_Profile_Info.devices.device4.sn = device4.sn
        new_Profile_Info.devices.device4.type = device4.type
      }
      else if (object.devices_resolved && object.devices_resolved.device4 && object.devices_resolved.device4.id !== "dissociate") {
        // Device belongs to another structure (shared patient): use backend-resolved details.
        new_Profile_Info.devices.device4.id = object.devices_resolved.device4.id
        new_Profile_Info.devices.device4.id_old = ""
        new_Profile_Info.devices.device4.nickname = object.devices_resolved.device4.nickname
        new_Profile_Info.devices.device4.sn = object.devices_resolved.device4.sn
        new_Profile_Info.devices.device4.type = object.devices_resolved.device4.type
      }
    }
    }

    // Authoritative fallback for shared patients: any device slot that still has an
    // unresolved id (device owned by another structure, or skipped above) is filled
    // from the backend-resolved details. Runs regardless of role / structure-device
    // list, so a shared user (e.g. an invited practitioner) sees the device/sensor
    // info in the patient box, profile modal and param-edit alike.
    if (object.devices_resolved) {
      ['device1', 'device2', 'device3', 'device4', 'device5'].forEach(slot => {
        const dr = object.devices_resolved[slot];
        const d = new_Profile_Info.devices[slot];
        if (d && dr && dr.id && dr.id !== "dissociate" && d.id !== "dissociate" && (!d.sn || !d.type)) {
          d.id = dr.id;
          d.id_old = "";
          d.nickname = dr.nickname;
          d.sn = dr.sn;
          d.type = dr.type;
        }
      });
    }

    let last_Profile_Info = last_Profile_Info_all.find(prev_data => prev_data.Patient_Data.id_patient === object.id_patient)

    //set observation with existing local data
    if (last_Profile_Info !== undefined) {
        new_Profile_Info.thermometer = last_Profile_Info.Patient_Data.thermometer;
        new_Profile_Info.position = last_Profile_Info.Patient_Data.position;
        new_Profile_Info.pulseOximeter = last_Profile_Info.Patient_Data.pulseOximeter;
        new_Profile_Info.pulseTensiometer = last_Profile_Info.Patient_Data.pulseTensiometer;
        new_Profile_Info.scale_data = last_Profile_Info.Patient_Data.scale_data;
        new_Profile_Info.pain = last_Profile_Info.Patient_Data.pain;
        new_Profile_Info.eq5d = last_Profile_Info.Patient_Data.eq5d;
        new_Profile_Info.sf36 = last_Profile_Info.Patient_Data.sf36;
        new_Profile_Info.mdasi = last_Profile_Info.Patient_Data.mdasi;
        new_Profile_Info.alimentation = last_Profile_Info.Patient_Data.alimentation;
        new_Profile_Info.kidney_device = last_Profile_Info.Patient_Data.kidney_device;
        new_Profile_Info.kidney_blood = last_Profile_Info.Patient_Data.kidney_blood;
        new_Profile_Info.photo = last_Profile_Info.Patient_Data.photo;
        new_Profile_Info.breathing = last_Profile_Info.Patient_Data.breathing;
        new_Profile_Info.MaxFeverDrawing = last_Profile_Info.Patient_Data.MaxFeverDrawing;
        new_Profile_Info.MaxHealthformDrawing = last_Profile_Info.Patient_Data.MaxHealthformDrawing;
        new_Profile_Info.MaxHealthscaleDrawing = last_Profile_Info.Patient_Data.MaxHealthscaleDrawing;
        new_Profile_Info.MaxPainDrawing = last_Profile_Info.Patient_Data.MaxPainDrawing;
        new_Profile_Info.MaxPulseRateDrawing = last_Profile_Info.Patient_Data.MaxPulseRateDrawing;
        new_Profile_Info.MaxPulseRateDrawingTension = last_Profile_Info.Patient_Data.MaxPulseRateDrawingTension;
        new_Profile_Info.MaxSystolicDrawingTension = last_Profile_Info.Patient_Data.MaxSystolicDrawingTension;
        new_Profile_Info.MaxDiastolicDrawingTension = last_Profile_Info.Patient_Data.MaxDiastolicDrawingTension;
        new_Profile_Info.MinSpO2Drawing = last_Profile_Info.Patient_Data.MinSpO2Drawing;
        new_Profile_Info.MaxBreathingRateDrawing = last_Profile_Info.Patient_Data.MaxBreathingRateDrawing;
        new_Profile_Info.MaxBreathingOxygenRateDrawing = last_Profile_Info.Patient_Data.MaxBreathingOxygenRateDrawing;
        new_Profile_Info.MaxBreathingLeakageDrawing = last_Profile_Info.Patient_Data.MaxBreathingLeakageDrawing;
        new_Profile_Info.MaxBreathingObservanceDrawing = last_Profile_Info.Patient_Data.MaxBreathingObservanceDrawing;
        new_Profile_Info.currentTimePoint = last_Profile_Info.Patient_Data.currentTimePoint;
    }

    return (new_Profile_Info)
}

const update_patient_check = async (id_patient, id_user, user_name, structure_name) => {
  return await DataServiceSQL.updatePatientCheckPatient(id_patient, id_user, user_name, structure_name)
  .then(response => {
    return response.data;
  })
  .catch(e => {
    console.log(e);
    return false;
  });
}

const update_patient_speciality = async (id_patient, speciality) => {
  return DataServiceSQL.patchPatientSpeciality(id_patient, speciality)
  .catch(e => {
    console.log(e);
  });
}

const search_practitioners = async (params) => {
  return DataServiceSQL.searchPractitioners(params)
  .then(response => {
    return response.data;
  })
  .catch(e => {
    console.log(e);
    return [];
  });
}

const list_practitioners_by_structure = async (targetStructureId, query = "") => {
  try {
    let res = await DataServiceSQL.listPractitionersByStructure(targetStructureId, query);
    return res.data;
  } catch(e) {
    console.log(e);
    return [];
  }
}

const list_existing_practitioners = async (query = "", structureId = null) => {
  try {
    let res = await DataServiceSQL.listExistingPractitioners(query, structureId);
    return Array.isArray(res.data) ? res.data : [];
  } catch(e) {
    console.log(e);
    return [];
  }
}

const attribute_practitioner_to_structure = async (id_user, FK_structure) => {
  try {
    let res = await DataServiceSQL.attributePractitionerToStructure(id_user, FK_structure, false);
    return res.data;
  } catch(e) {
    console.log(e);
    return null;
  }
}

const send_practitioner_credentials = async (params) => {
  try {
    let res = await DataServiceSQL.sendPractitionerCredentials(params);
    return res.data;
  } catch(e) {
    console.log(e);
    throw e;
  }
}

const send_practitioner_reset_link = async (params) => {
  try {
    let res = await DataServiceSQL.sendPractitionerResetLink(params);
    return res.data;
  } catch(e) {
    console.log(e);
    throw e;
  }
}

const create_or_update_local_practitioner = async (data) => {
  try {
    let res = await DataServiceSQL.createOrUpdateLocalPractitioner(data);
    return res.data;
  } catch(e) {
    console.log(e);
    return null;
  }
}

const get_local_practitioner = async (rpps) => {
  try {
    let res = await DataServiceSQL.getLocalPractitioner(rpps);
    return res.data;
  } catch(e) {
    return null;
  }
}

const update_patient_practitioner_speciality = async (id_patient, rpps) => {
  return DataServiceSQL.patchPatientPractitionerSpeciality(id_patient, rpps)
  .catch(e => {
    console.log(e);
  });
}

const update_patient_ordonnance = async (id_patient, ordonnance_file, ordonnance_filename) => {
  return DataServiceSQL.patchPatientOrdonnance(id_patient, ordonnance_file, ordonnance_filename)
  .catch(e => {
    console.log(e);
  });
}

const download_patient_consentement = async (id_patient) => {
  try {
    let res = await DataServiceSQL.getPatientConsentementDownload(id_patient);
    return res.data;
  } catch(e) {
    console.log(e);
    return null;
  }
}

const download_patient_ordonnance = async (id_patient) => {
  try {
    let res = await DataServiceSQL.getPatientOrdonnanceDownload(id_patient);
    return res.data;
  } catch(e) {
    console.log(e);
    return null;
  }
}

const update_patient_consentement = async (id_patient, consentement_file, consentement_filename) => {
  return DataServiceSQL.patchPatientConsentement(id_patient, consentement_file, consentement_filename)
  .catch(e => {
    console.log(e);
  });
}

const update_patient_psad = async (id_patient, psad_delegate_alerts, psad_delegate) => {
  return DataServiceSQL.patchPatientPsad(id_patient, psad_delegate_alerts, psad_delegate || null)
  .catch(e => {
    console.log(e);
  });
}

const update_patient_delegate_medical = async (id_patient, delegate_medical_alert) => {
  return DataServiceSQL.patchPatientDelegateMedical(id_patient, delegate_medical_alert || null)
  .catch(e => {
    console.log(e);
  });
}

const update_patient_delegate_non_medical = async (id_patient, delegate_non_medical_alert) => {
  return DataServiceSQL.patchPatientDelegateNonMedical(id_patient, delegate_non_medical_alert)
  .catch(e => {
    console.log(e);
  });
}

const update_patient_lpp_code = async (id_patient, lpp_code) => {
  return DataServiceSQL.patchPatientLppCode(id_patient, lpp_code || null)
  .catch(e => {
    console.log(e);
  });
}

const send_patient_share_invite = async (id_patient, recipient_email, delegate_name, delegate_phone) => {
  return DataServiceSQL.postPatientShareInvite(id_patient, recipient_email, delegate_name, delegate_phone)
  .catch(e => {
    console.log(e);
  });
}

const send_patient_share_invite_structures = async (id_patient, structure_ids, delegate_name, delegate_phone, invite_type, sharing_type) => {
  try {
    let res = await DataServiceSQL.postPatientShareInviteStructures(id_patient, structure_ids, delegate_name, delegate_phone, invite_type, sharing_type);
    return res.data || null;
  } catch(e) {
    console.log(e);
    return null;
  }
}

const get_patient_structure_shares = async (id_patient) => {
  try {
    let res = await DataServiceSQL.getPatientStructureShares(id_patient);
    return res.data || [];
  } catch(e) {
    console.log(e);
    return [];
  }
}

const update_patient_structure_share = async (id_patient, structure_id, permissions) => {
  try {
    let res = await DataServiceSQL.patchPatientStructureShare(id_patient, structure_id, permissions);
    return res.data || null;
  } catch(e) {
    console.log(e);
    return null;
  }
}

const delete_patient_structure_share = async (id_patient, structure_id) => {
  try {
    let res = await DataServiceSQL.deletePatientStructureShare(id_patient, structure_id);
    return res.data || null;
  } catch(e) {
    console.log(e);
    return null;
  }
}

const revoke_my_delegate_share = async (id_patient, structure_id) => {
  try {
    let res = await DataServiceSQL.deleteMyDelegateStructureShare(id_patient, structure_id);
    return res && (res.status === 200 || res.status === 204);
  } catch(e) {
    console.log(e);
    return false;
  }
}

const get_patient_pending_invites = async (id_patient) => {
  try {
    let res = await DataServiceSQL.getPatientPendingInvites(id_patient);
    return res.data || [];
  } catch(e) {
    console.log(e);
    return [];
  }
}

const delete_patient_pending_invite = async (id_patient, request_id) => {
  try {
    let res = await DataServiceSQL.deletePatientPendingInvite(id_patient, request_id);
    return res && (res.status === 200 || res.status === 204);
  } catch(e) {
    console.log(e);
    return false;
  }
}

const get_structures_by_type = async (type) => {
  try {
    let res = await DataServiceSQL.getStructuresByType(type);
    return res.data || [];
  } catch(e) {
    console.log(e);
    return [];
  }
}

// PSAD structures available to the caller's own structure (concerned-speciality dropdown).
// Falls back server-side to all PSAD structures when none are explicitly assigned.
const get_available_psad_structures = async () => {
  try {
    let res = await DataServiceSQL.getAvailablePsadStructures();
    return res.data || [];
  } catch(e) {
    console.log(e);
    return [];
  }
}

const create_structure = async (structureData) => {
  try {
    let res = await DataServiceSQL.createStructure(structureData);
    return res.data;
  } catch(e) {
    console.log(e);
    return null;
  }
}

//Const to import functions in other files
const PatientFunctionsGetter = {
  create_patient_fhir,
  get_Patients,
  search_Patients,
  update_SQL_patient,
  update_patient_speciality,
  search_practitioners,
  list_practitioners_by_structure,
  list_existing_practitioners,
  attribute_practitioner_to_structure,
  send_practitioner_credentials,
  send_practitioner_reset_link,
  create_or_update_local_practitioner,
  get_local_practitioner,
  update_patient_practitioner_speciality,
  update_patient_ordonnance,
  update_patient_consentement,
  download_patient_consentement,
  download_patient_ordonnance,
  update_patient_psad,
  update_patient_delegate_medical,
  update_patient_delegate_non_medical,
  update_patient_lpp_code,
  send_patient_share_invite,
  send_patient_share_invite_structures,
  get_patient_structure_shares,
  update_patient_structure_share,
  delete_patient_structure_share,
  revoke_my_delegate_share,
  get_patient_pending_invites,
  delete_patient_pending_invite,
  get_structures_by_type,
  get_available_psad_structures,
  create_structure,
  convert_patient_input_data,
  prismacloudPatientById,
  update_patient_check
};

export default PatientFunctionsGetter;
